module.exports = __webpack_public_path__ + "img/USA-Flag-removebg-preview.1d0237c0.png";